import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  span:nth-child(2) {
    font-size: 12px;
    color: #64748b;
  }
`

interface ContractorCompanyNameProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}
const ContractorCompanyName = ({ cell: { row } }: ContractorCompanyNameProps) => {
  const contractor = row.original.rowSettings.item

  return (
    <Container>
      <span>{contractor.name}</span>
      <span>{contractor?.parent_company?.name || ""}</span>
    </Container>
  )
}

export default ContractorCompanyName
